import { render, staticRenderFns } from "./ConcernDoubletOverview.vue?vue&type=template&id=7d28548a"
import script from "./ConcernDoubletOverview.vue?vue&type=script&lang=js"
export * from "./ConcernDoubletOverview.vue?vue&type=script&lang=js"
import style0 from "./ConcernDoubletOverview.vue?vue&type=style&index=0&id=7d28548a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports